import { canNavigate } from "@/plugins/acl/routeProtection";
import Vue from "vue";
import VueBodyClass from "vue-body-class";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    redirect: (to) => {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const userRole = userData && userData.role ? userData.role : null;

      if (userRole === "CALLC") return { name: "dashboard-call-center" };
      if (userRole !== "CALLC") return { name: "dashboard" };

      return { name: "auth-login", query: to.query };
    },
  },
  {
    path: "/login",
    name: "auth-login",
    component: () => import("@/views/Login.vue"),
    meta: {
      layout: "blank",
      resource: "Public",
      redirectIfLoggedIn: true,
      bodyClass: "public",
    },
  },
  {
    path: "/forgot-password",
    name: "auth-forgot-password",
    component: () => import("@/views/ForgotPassword.vue"),
    meta: {
      layout: "blank",
      resource: "Public",
      redirectIfLoggedIn: true,
      bodyClass: "public",
    },
  },
  {
    path: "/reset-password",
    name: "auth-reset-password",
    component: () => import("@/views/ResetPassword.vue"),
    meta: {
      layout: "blank",
      resource: "Public",
      bodyClass: "public",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/Error404.vue"),
    meta: {
      layout: "blank",
      bodyClass: "public",
      resource: "Public",
    },
  },
  {
    path: "/not-authorized",
    name: "misc-not-authorized",
    component: () => import("@/views/NotAuthorized.vue"),
    meta: {
      layout: "blank",
      bodyClass: "public",
      resource: "Public",
    },
  },

  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/dashboard/Index.vue"),
    meta: {
      layout: "content",
      resource: "Dashboard",
    },
  },

  {
    path: "/dashboard-call-center",
    name: "dashboard-call-center",
    component: () => import("@/views/dashboard/callCenter/Index.vue"),
    meta: {
      layout: "content",
      resource: "callCenter",
    },
  },

  {
    path: "/call-center/list",
    name: "call-center-list",
    component: () => import("@/views/callCenter/list/Index.vue"),
    meta: {
      layout: "content",
      resource: "callCenter",
    },
  },

  {
    path: "/call-center/order",
    name: "call-center-order",
    component: () => import("@/views/callCenter/order/Index.vue"),
    meta: {
      layout: "content",
      resource: "callCenter",
      navActiveLink: "call-center-list",
    },
  },
  {
    path: "/call-center/view",
    name: "call-center-view",
    component: () => import("@/views/callCenter/view/Index.vue"),
    meta: {
      layout: "content",
      resource: "callCenter",
      navActiveLink: "call-center-list",
    },
  },
  {
    path: "/manager/list",
    name: "manager-list",
    component: () => import("@/views/manager/Index.vue"),
    meta: {
      layout: "content",
      resource: "asl-managers",
    },
  },
  {
    path: "/user/list",
    name: "user-list",
    component: () => import("@/views/user/user-list/Index.vue"),
    meta: {
      layout: "content",
      resource: "asl-users",
    },
  },
  {
    path: "/user/view",
    name: "user-view",
    component: () => import("@/views/user/user-view/UserView.vue"),
    meta: {
      layout: "content",
      resource: "Finans",
      navActiveLink: "user-list",
    },
  },
  {
    path: "/user/addresses",
    name: "user-addresses",
    component: () => import("@/views/user/user-addresses/UserAddresses.vue"),
    meta: {
      layout: "content",
      resource: "UserProfiles",
      navActiveLink: "user-list",
    },
  },
  {
    path: "/user/contracts",
    name: "user-contracts",
    component: () => import("@/views/user/user-contracts/UserContracts.vue"),
    meta: {
      layout: "content",
      resource: "KPanel",
      navActiveLink: "user-list",
    },
  },
  {
    path: "/order/order-to/:type",
    name: "order-to",
    component: () => import("@/views/order/order-to/OrderTo.vue"),
    meta: {
      layout: "content",
      resource: "asl-order-mamul",
    },
  },

  {
    path: "/order/order-product/:type",
    name: "order-product",
    component: () => import("@/views/order/order-product/OrderProduct.vue"),
    meta: {
      layout: "content",
      resource: "asl-order-mamul-easy",
    },
    beforeEnter(to, _, next) {
      if (["mamul", "sarf"].includes(to.params.type)) next();
      else next({ name: "error-404" });
    },
  },

  {
    path: "/order/cake",
    name: "order-cake",
    component: () => import("@/views/order/order-cake/Index.vue"),
    meta: {
      layout: "content",
      resource: "asl-order-mamul-easy",
    },
  },

  {
    path: "/order/completed",
    name: "order-completed",
    component: () => import("@/views/order/completed/Completed.vue"),
    meta: {
      layout: "content",
      resource: "KPanel",
    },
  },

  {
    path: "/extract",
    name: "extract-list",
    component: () => import("@/views/extract/ExtractList.vue"),
    meta: {
      layout: "content",
      resource: "asl-extract",
    },
  },
  {
    path: "/payment-tracking",
    name: "payment-tracking",
    component: () => import("@/views/paymentTracking/DataList.vue"),
    meta: {
      layout: "content",
      resource: "asl-payments",
    },
  },
  {
    path: "/documents/:folder",
    name: "documents-list",
    component: () => import("@/views/documents/DocumentsList.vue"),
    meta: {
      layout: "content",
      resource: "asl-sales-document",
    },
    beforeEnter(to, _, next) {
      if (["order", "waybill", "bill", "HF", "Y1", "R1"].includes(to.params.folder)) next();
      else next({ name: "error-404" });
    },
  },
  {
    path: "/purchases",
    name: "purchases",
    component: () => import("@/views/purchases/Purchases.vue"),
    meta: {
      layout: "content",
      resource: "KPanel",
    },
  },

  {
    path: "/payment",
    name: "payment",
    component: () => import("@/views/payment/Payment.vue"),
    meta: {
      layout: "content",
      resource: "asl-manual-payment",
    },
  },

  {
    path: "/credit-card-transactions",
    name: "credit-card-transactions",
    component: () => import("@/views/creditCardTransactions/DataList.vue"),
    meta: {
      layout: "content",
      resource: "asl-payment-tracking",
    },
  },

  {
    path: "/cash-report",
    name: "cash-report",
    component: () => import("@/views/cashReport/DataList.vue"),
    meta: {
      layout: "content",
      resource: "asl-cash-report",
    },
  },

  {
    path: "/complaint-request",
    name: "complaint-request",
    component: () => import("@/views/complaintRequest/Index.vue"),
    meta: {
      layout: "content",
      resource: "asl-request-tracking",
    },
  },
  {
    path: "/complaint-request/new",
    name: "complaint-request-new",
    component: () => import("@/views/complaintRequest/New.vue"),
    meta: {
      layout: "content",
      resource: "asl-request-tracking",
      navActiveLink: "complaint-request",
    },
  },
  {
    path: "/complaint-request/view",
    name: "complaint-request-view",
    component: () => import("@/views/complaintRequest/View.vue"),
    meta: {
      layout: "content",
      resource: "asl-request-tracking",
      navActiveLink: "complaint-request",
    },
  },
  {
    path: "/logs",
    name: "logs",
    component: () => import("@/views/logs/DataList.vue"),
    meta: {
      layout: "content",
      resource: "Logs",
    },
  },
  {
    path: "/aging-report",
    name: "aging-report",
    component: () => import("@/views/agingReport/AgingReport.vue"),
    meta: {
      layout: "content",
      resource: "Payment",
    },
  },
  {
    path: "/product/call",
    name: "product-call",
    component: () => import("@/views/products/product-call/Index.vue"),
    meta: {
      layout: "content",
      resource: "asl-products-callcenter",
    },
  },
  {
    path: "/product/mamul",
    name: "product-mamul",
    component: () => import("@/views/products/product-mamul/ProductList.vue"),
    meta: {
      layout: "content",
      resource: "asl-products-mamul",
    },
  },
  {
    path: "/product/sarf",
    name: "product-sarf",
    component: () => import("@/views/products/product-sarf/ProductList.vue"),
    meta: {
      layout: "content",
      resource: "asl-products-sarf",
    },
  },
  {
    path: "/product/category",
    name: "product-category",
    component: () => import("@/views/products/product-category/ProductCategoryList.vue"),
    meta: {
      layout: "content",
      resource: "asl-categories",
    },
  },
  {
    path: "/root",
    name: "root",
    component: () => import("@/views/root/Index.vue"),
    meta: {
      layout: "content",
      resource: "asl-root",
    },
  },
  {
    path: "/product/view",
    name: "product-view",
    component: () => import("@/views/products/product-view/ProductView.vue"),
    meta: {
      layout: "content",
      resource: "ProductsMan",
      navActiveLink: "product-list",
    },
  },
  {
    path: "/dbs/list",
    name: "dbs-list",
    component: () => import("@/views/dbs/dbs-list/DbsList.vue"),
    meta: {
      layout: "content",
      resource: "asl-dbs",
    },
  },
  {
    path: "/event/list",
    name: "event-list",
    component: () => import("@/views/events/event-list/EventList.vue"),
    meta: {
      layout: "content",
      resource: "asl-notifications",
    },
  },
  {
    path: "/event/view",
    name: "event-view",
    component: () => import("@/views/events/event-view/EventView.vue"),
    meta: {
      layout: "content",
      resource: "asl-notifications",
      navActiveLink: "event-list",
    },
  },
  {
    path: "/order-approval",
    name: "order-approval",
    component: () => import("@/views/orderApproval/approval-list/ApprovalList.vue"),
    meta: {
      layout: "content",
      resource: "asl-order-confirmation",
    },
  },
  {
    path: "/order-tracking",
    name: "order-tracking",
    component: () => import("@/views/orderTracking/tracking-list/TrackingList.vue"),
    meta: {
      layout: "content",
      resource: "asl-order-tracking",
    },
  },
  {
    path: "/order-tracking/view",
    name: "order-tracking-view",
    component: () => import("@/views/orderTracking/tracking-view/TrackingView.vue"),
    meta: {
      layout: "content",
      resource: "Sales",
    },
  },
  {
    path: "/settings/",
    name: "settings-view",
    component: () => import("@/views/settings/SettingsView.vue"),
    meta: {
      layout: "content",
      resource: "asl-settings",
    },
  },

  {
    path: "*",
    redirect: "error-404",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
const vueBodyClass = new VueBodyClass(routes);

router.beforeEach((to, _, next) => {
  const userData = localStorage.getItem("userData");

  const isLoggedIn =
    userData && localStorage.getItem("accessToken") && localStorage.getItem("userAbility");
  if (!canNavigate(to)) {
    // Redirect to login if not logged in

    if (!isLoggedIn)
      return next({ name: "auth-login", query: { marketplace: to.query.marketplace } });

    // If logged in => not authorized
    return next({ name: "misc-not-authorized" });

    // return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next("/");
  }

  return next();
});
router.beforeEach((to, from, next) => {
  vueBodyClass.guard(to, next);
});

export default router;
